<template>
<div>
<b-navbar type="dark" variant="dark" class="navbar-wrapper">
    <b-navbar-brand href="/" class="navbar-brand">
    <img :src="logo" class="navbar-logo" v-if="branding.logo == undefined">
    <img :src="brandlogo" class="navbar-logo" v-else>
    </b-navbar-brand>
</b-navbar>
</div>
</template>
<style scoped>
.navbar-wrapper {
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 998;
}
.navbar-brand {
  height:75px;
}
.navbar-logo {
  height: 65px;
  padding: 5px;
}
</style>
<script>

import { mapState } from 'vuex'
import logo from '@/assets/images/branding/cloudbaselogo.png'

export default { 
  data(){
    return{
      logo,
      brandlogo:''   
    }
  },

 
    computed: mapState(['branding','countryid','resellerid','dealerid','companyid']), 

     watch: {
				branding() {
                    this.brandlogo = process.env.VUE_APP_API_BASE_URL + this.branding.logo
        },
    },
}
</script>